import { useContext } from "react";

import { ISettings } from "./settingsTypes";
import { SettingsContext } from "./context";

export const useSettings = (): ISettings => {

    const context = useContext(SettingsContext);
    if (!context)
        throw new Error("SettingsContext not found");

    return context.settings;
};